// extracted by mini-css-extract-plugin
export default {"container":"TooltipBody_container__yu6c8","fixed":"TooltipBody_fixed__sTFZ6"};